import { NgModule } from '@angular/core';
import { PLikeDislikeComponent } from './p-like-dislike.component';
import { PButtonModule } from '@panaya/ui/p-button';
import { AnimationLoader, LottieModule, provideLottieOptions } from 'ngx-lottie';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
    declarations: [PLikeDislikeComponent],
    imports: [PButtonModule, LottieModule, MatTooltipModule],
    exports: [PLikeDislikeComponent],
    providers: [
        provideLottieOptions({
            player: () => import('lottie-web')
        }),
        AnimationLoader
    ]
})
export class PLikeDislikeModule {}
